import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCSTEMComputersScratchClassesProjectsUndertaken = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Scratch classes / projects undertaken (%)" />
    </Box>
  );
};
